import apiPdca from '../../../../helpers/apiPdca'
import { loading, loaded, modalAlertaInfo, modalAlertaClean } from '../../../../layout/redux/layoutActions'

import {
  DETALHEPLANO_FETCH_REQUEST,
  DETALHEPLANO_FETCH_SUCCESS,
  DETALHEPLANO_FETCH_FAILURE,
  DETALHEPLANO_CLEAR
} from './detalheplanoReducer'

export const fetchDetalhePlano = planoId => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: DETALHEPLANO_FETCH_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.get(`/pdca/planos/detalheplano?planoId=${planoId}`)

      const data = response?.data

      if (!data?.ok) {
        throw new Error('Erro ao carregar detalhe do plano.')
      }

      dispatch({
        type: DETALHEPLANO_FETCH_SUCCESS,
        payload: data
      })
    } catch (error) {
      dispatch({
        type: DETALHEPLANO_FETCH_FAILURE,
        payload: error?.message || 'Erro ao carregar detalhe do plano.'
      })

      dispatch(
        modalAlertaInfo({
          ...nlsPopup[7],
          btnAction: () => dispatch(modalAlertaClean()),
          show: true
        })
      )
    } finally {
      dispatch(loaded())
    }
  }
}

export const clearDetalhePlano = () => {
  return {
    type: DETALHEPLANO_CLEAR
  }
}